export function isAfter(date1, date2) {
    return date1.getTime() > date2.getTime();
}
export function differenceInYears(date1, date2) {
    const yearDiff = date1.getFullYear() - date2.getFullYear();
    return yearDiff;
}
export function getYearsList(currentDate, minDate, maxDate, yearsCount = 100) {
    const currentYear = currentDate.getFullYear();
    // Handle invalid date range
    if (minDate && maxDate && minDate.getTime() > maxDate.getTime()) {
        return [];
    }
    // Determine start year
    let startYear;
    if (minDate) {
        startYear = minDate.getFullYear();
    }
    else if (maxDate) {
        startYear = maxDate.getFullYear() - yearsCount;
    }
    else {
        startYear = currentYear - yearsCount / 2;
    }
    // Determine end year
    let endYear;
    if (maxDate) {
        endYear = maxDate.getFullYear();
    }
    else if (minDate) {
        endYear = minDate.getFullYear() + yearsCount;
    }
    else {
        endYear = currentYear + yearsCount / 2;
    }
    // Generate years array
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
        years.push(year);
    }
    return years;
}
